import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'motion/react';
import ShareLinks from '../molecules/ShareLinksBK';
import ActionButton from '../atoms/ActionButton';
import Ads from '../atoms/Ads';
import { useLetterStore } from '@/store/letterStore';
import { useAiStore } from '@/store/aiStore';

const TopView: React.FC = () => {
  const { letterData, clearLetterData } = useLetterStore();
  console.log('letterData', letterData);
  const { clearAiData } = useAiStore();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/question');
  };

  useEffect(() => {
    clearLetterData();
    clearAiData();
  }, [clearLetterData, clearAiData]);

  return (
    <div id='page' className='dark-bg'>
      <header className='h-header'>
        <div className='letter-cover'>
          <img src='/img/home/img-letter.png' alt='SKALE' />
        </div>
        <motion.h1
          className='h-header__title'
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            duration: 0.5,
            delay: 0.5,
            ease: [0.55, 0.055, 0.675, 0.19], // easeInCubic相当
          }}
        >
          たった1つのメッセージ
        </motion.h1>
      </header>

      <div id='contents'>
        <div className='h-intro'>
          <motion.div
            className='h-intro__txt'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              duration: 0.5,
              delay: 1.0, // ヘッダータイトルのアニメーション完了後
              ease: [0.55, 0.055, 0.675, 0.19], // easeInCubic相当
            }}
          >
            <p className='u-center'>
              いつもとは違う
              <br />
              特別なアドレス(URL)で
              <br />
              メッセージを送ろう
            </p>
          </motion.div>

          <div className='c-btn-width'>
            <ActionButton onClick={handleClick}>メッセージを作る</ActionButton>
          </div>
        </div>
      </div>

      <footer className='l-footer p-footer'>
        <Ads />
      </footer>
    </div>
  );
};

export default TopView;
